import { ChipCellRenderer } from "@/controls/ag-grid/components/ChipCellRenderer";
import {
	dxtToLocalServerTime,
	getMomentTz,
	useShiftNavigator,
} from "@dexteel/mesf-core";
import { ColDef, ValueGetterParams } from "ag-grid-enterprise";
import { get } from "lodash-es";
import {
	LinkCellRenderer,
	ManualIconCellRenderer,
} from "../../../../controls/ag-grid/components/ButtonCellRenderer";

type Props = {};

const moment = getMomentTz();
export const useTableData = ({}: Props) => {
	const { shiftInfo } = useShiftNavigator();
	const shiftId = get(shiftInfo, "CurrentShiftId", null);
	const columns: ColDef[] = [
		{
			field: "AssetName",
			headerName: "EAF",
			cellRenderer: ChipCellRenderer,
			cellClass: (params) =>
				params.data.AssetId ? `eaf-${params.data.AssetId}` : "",
			minWidth: 88,
			flex: 1,
		},
		{
			field: "HeatName",
			headerName: "Heat",

			cellRenderer: (params: any) => {
				return LinkCellRenderer({
					...params,
					link: `/meltshop-heats/${shiftId}?heatId=${params.data.HeatId}`,
				});
			},
			minWidth: 70,
			flex: 1,
		},
		{
			field: "GradeName",
			headerName: "Grade",
			minWidth: 79,
			flex: 1,
		},
		{
			field: "LadleName",
			headerName: "Ladle",
			minWidth: 60,
			flex: 1,
		},
		{
			field: "Start",
			headerName: "Start",
			cellRenderer: (params: any) => {
				return LinkCellRenderer({
					...params,
					link: `/eaf-data-entry/${params.data.ProcessId}`,
				});
			},
			minWidth: 62,
			valueGetter: (params) =>
				params.data.Start ? moment(params.data?.Start).format("HH:mm") : "",
			flex: 1,
		},
		{
			field: "End",
			headerName: "End",
			valueGetter: (params) =>
				params.data.End ? moment(params.data?.End).format("HH:mm") : "",
			minWidth: 62,

			flex: 1,
		},
		{
			field: "TapToTap",
			headerName: "Tap To Tap",
			minWidth: 85,
			wrapHeaderText: true,
			cellStyle: {
				textAlign: "right",
			},
			flex: 1,
		},
		{
			field: "PowerOn",
			headerName: "Power On",
			wrapHeaderText: true,
			cellStyle: {
				textAlign: "right",
			},
			minWidth: 80,
			flex: 1,
		},
		{
			field: "MWH",
			headerName: "MWH",
			valueGetter: (params: ValueGetterParams) => {
				return params.data.MWH ? params.data.MWH.toFixed(1) : "";
			},
			minWidth: 60,
			cellStyle: {
				textAlign: "right",
			},
			flex: 1,
		},
		{
			field: "OxygenVolume",
			headerName: "O2 Vol [scf]",
			valueGetter: (params: ValueGetterParams) => {
				return params.data.OxygenVolume
					? params.data.OxygenVolume.toFixed(1)
					: "";
			},
			minWidth: 100,
			cellStyle: {
				textAlign: "right",
			},
			flex: 1,
		},
		{
			field: "Charges",
			headerName: "Charges",
			minWidth: 76,
			cellStyle: {
				textAlign: "right",
			},
			flex: 1,
		},
		{
			field: "ScrapTons",
			headerName: "Scrap [lbs]",
			minWidth: 95,
			cellStyle: {
				textAlign: "right",
			},
			flex: 1,
		},
		{
			field: "LastTemperature",
			headerName: "Last Temp",
			minWidth: 90,
			cellStyle: {
				textAlign: "right",
			},
			flex: 1,
		},
		{
			field: "TrimProbeTemperature",
			headerName: "Trim Temp",
			minWidth: 88,
			cellStyle: {
				textAlign: "right",
			},
			flex: 1,
		},
		{
			field: "DeltaT",
			headerName: "Delta T",
			minWidth: 68,
			cellStyle: {
				textAlign: "right",
			},
			flex: 1,
		},
		{
			field: "SteelWeight",
			headerName: "Steel Weight",
			minWidth: 102,
			cellStyle: {
				textAlign: "right",
			},
			flex: 1,
		},
		{
			field: "IsProcessManual",
			headerName: "",
			cellRenderer: ManualIconCellRenderer,
			minWidth: 50,
			maxWidth: 50,
			flex: 1,
		},
		{
			field: "Name",
			headerName: "",
			type: ["nonSorteable", "nonFilterable", "optionsButton"],
			maxWidth: 150,
			minWidth: 150,
			editable: false,
		},
	];

	return { columns };
};
